import Text from '../../../Text'
import { $textPrimary } from '../../../../styles/colors/semantics'
import React from 'react'
import styles from './styles.module.css'
import { renderShopItem } from '../index'
import Spacer from '../../../Spacer'
// ChristmasLights is rendered UNCONDITIONALLY below, and BF2025 is a child of the
// Shop island — which is hosted on the RSC server path (RenderSectionsServer
// ISLAND_SECTIONS) whenever /shop has a "Holiday Sale" category. A `next/dynamic`
// here synthesizes a pending streaming-Suspense boundary INSIDE the Shop island's
// SSR subtree, which defers the ENTIRE product grid to a client-only render (the
// #130 / React #418/#422 class) — the /shop empty-server-grid bug. Static-import
// instead: BF2025 only renders on the seasonal Holiday-Sale surface, and the SVG
// is now a ~5.5 KB off-JS-raster icon (task #67), so it costs year-round visitors
// nothing while introducing NO streaming-Suspense boundary. Mirrors the identical
// fix already applied to its sibling BF2024Hero (#118 slice 7 / #130).
import ChristmasLights from '../../../icons/ChristmasLights'

// Reproduce the former styled `ShopItems` `numItems` switch (min-768px child width)
// as a CSS custom property. Returns undefined for the fall-through cases (no width),
// matching the old styled function returning undefined.
const shopItemWidthFor = (numItems) => {
  if (numItems === 2) return 'calc(40% - 16px)'
  if (numItems === 3) return 'calc(33.33% - 16px)'
  if (numItems === 4 || numItems === 1 || numItems > 4) return 'calc(33% - 16px)'
  return undefined
}

function BF2025({ items, isLoading, subtitle, hideHeader }) {
  const shownItems = items
    .filter(i => i.displayOnShop)
    .filter(i => i.available)
    .filter(i => i.category.displayName === 'Holiday Sale')

  // const specialDiscounts = shownItems.filter(i => i.timeLimit || i.stockLimit)
  const specialDiscounts = shownItems

  return (
    <>
      <Spacer size={16}/>
      <div className="z-0 absolute md:block hidden">
        <ChristmasLights/>
      </div>
      {
        specialDiscounts && specialDiscounts.length > 0 && <div className={styles.blackFridaySpecialDeals}>
          <div className={styles.shopItemsTitle}>
            <Text type="heading-2" color={$textPrimary.holiday}>Special deals</Text>
          </div>
          <div className={styles.shopItems} style={{ '--shop-item-width': shopItemWidthFor(specialDiscounts.length) }}>
            {
              shownItems
                .filter(i => i.timeLimit || i.stockLimit || i.externalLink)
                .map((shopItem) => renderShopItem(shopItem, isLoading, true, false, -1, items))
            }
          </div>
        </div>
      }
      <Spacer size={16}/>
    </>
  )
}

export default BF2025
